export default __webpack_public_path__ + "static/media/ic_home.1a6fb2e9.svg";